export const USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_TIME_OUT = 2000

export const USE_LOAD_DOCUMENT_STAPLING_COMBINING_PHASE_ASYNC_STATUS_SUCCESS =
  'SUCCESS'
